var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataAvailability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#777"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#data-availability_svg__clip0_909_793)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66.6c0-.79 1.22-.79 1.22 0v1.83c0 .79-1.22.79-1.22 0V.6zm7.39 0c0-.79 1.22-.79 1.22 0v1.83c0 .79-1.22.79-1.22 0V.6zm3.66 4.89H1.22v8.61c0 .37.31.61.61.61H14.1c.37 0 .61-.24.61-.61V5.48v.01zM3.05 1.21v1.22c0 1.65 2.5 1.65 2.5 0V1.21h4.89v1.22c0 1.65 2.44 1.65 2.44 0V1.21h1.22c1.04 0 1.89.85 1.89 1.83v11.05c0 1.04-.86 1.83-1.89 1.83H1.83c-.98 0-1.83-.79-1.83-1.83V3.04c0-.98.85-1.83 1.83-1.83h1.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99 12.49c-.21 0-.41-.08-.56-.23l-1.57-1.57a.779.779 0 010-1.11c.31-.31.8-.31 1.11 0l.95.95 3.06-2.54c.27-.34.77-.39 1.11-.12.34.27.39.77.12 1.11l-3.6 3.22c-.14.18-.35.28-.57.29h-.05z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "data-availability_svg__clip0_909_793"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v15.92H0z"
  })))));
}
export default SvgDataAvailability;